import { render } from "./ui-table.vue?vue&type=template&id=7f6bae26&ts=true"
import script from "./ui-table.vue?vue&type=script&lang=ts"
export * from "./ui-table.vue?vue&type=script&lang=ts"

import "./ui-table.vue?vue&type=style&index=0&id=7f6bae26&lang=scss"

import exportComponent from "/root/workspace/__flow_work/__flow_builds/1fe6d5c2-02f8-4b7b-a7ed-3827401bba29/workspace/toilet-go-front_Ak2Q/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__